import { HttpErrorResponse } from "@angular/common/http";

export function getErrorMessageFromHttpErrorResponse(
  httpErrorResponse: HttpErrorResponse
): string {
  if (httpErrorResponse.error?.message) {
    return httpErrorResponse.error.message;
  }

  return httpErrorResponse.message;
}
